export default __webpack_public_path__ + "static/media/sunset.7ec33c8f.svg";